module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19c1PUv/tc-custom/9781449423483.jpg?1706903564390",
      "alt": "This image is the cover for the book 25 Movies to Mend a Broken Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("25 Movies to Mend a Broken Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ahh, love. It can be a many splendored thing, but it can also lead to the pain of a broken heart. For those experiencing such a sad eventuality, turn to this e-book only selection of Ebert's Essentials, and consider these reviews of movies to help get you through the heartbreak. While not a cure for a broken heart (what could be?), watching these films can bring hope and appreciation for the possibility of love again or just help you laugh at the total absurdity of it all. Enjoy such classic romantic comedies as "), _c('i', [_vm._v("Moonstruck ")]), _vm._v("and "), _c('i', [_vm._v("Annie Hall")]), _vm._v(" to the decidedly offbeat "), _c('i', [_vm._v("Lars and the Real Girl")]), _vm._v(" that will help bring a smile back. Appreciate quiet looks into love with films like "), _c('i', [_vm._v("The Scent of Green Papaya")]), _vm._v(" and "), _c('i', [_vm._v("Once")]), _vm._v(". ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roger Ebert\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0